import React from 'react';
import * as LuIcons from 'react-icons/lu';
const { LuLink, LuCpu, LuBarChart2, LuPiggyBank } = LuIcons;
import SafeIcon from '../common/SafeIcon';

export default function HowItWorks() {
  const steps = [
    { num: "01", icon: LuLink, title: "Paste Product URL", desc: "Find a product you want on Amazon, Walmart, or any major retailer and paste the link." },
    { num: "02", icon: LuCpu, title: "AI Analyzes Product", desc: "Our engine scans thousands of retailers, historical data, and reviews in seconds." },
    { num: "03", icon: LuBarChart2, title: "Compare Prices", desc: "View a clean dashboard showing the true cost including shipping and taxes." },
    { num: "04", icon: LuPiggyBank, title: "Save Money", desc: "Buy from the cheapest trusted seller or wait for the AI-predicted price drop." }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-slate-900 text-white relative overflow-hidden">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-blue-600/10 blur-3xl transform translate-x-1/2"></div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4">How Cheapo AI Works</h2>
          <p className="text-lg text-slate-400">Save money in four simple steps without leaving your browser.</p>
        </div>

        <div className="grid md:grid-cols-4 gap-8">
          {steps.map((step, idx) => (
            <div key={idx} className="relative group">
              {idx !== steps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-1/2 w-full h-0.5 bg-slate-800 -z-10"></div>
              )}
              <div className="bg-slate-800 w-16 h-16 rounded-2xl flex items-center justify-center text-blue-400 mb-6 mx-auto border border-slate-700 group-hover:border-blue-500 transition-colors shadow-lg">
                <SafeIcon icon={step.icon} className="text-2xl" />
              </div>
              <div className="text-center">
                <div className="text-blue-500 font-mono text-sm font-bold mb-2">STEP {step.num}</div>
                <h4 className="text-xl font-bold mb-3">{step.title}</h4>
                <p className="text-slate-400 text-sm leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}